const REVEAL_DISTANCE = 10
const MEASURE_TIMEOUT = 4000

const root = document.documentElement
const isProduct = document.body.classList.contains('bdy-Template-product')
const trigger = document.querySelector('.lsp-Trigger')

if (trigger) {
  let height =
    Number.parseInt(
      window.getComputedStyle(root).getPropertyValue('--LoyaltyTrigger_Height'),
      10,
    ) || 0
  let measured = false
  let lastY = window.scrollY
  let upDistance = 0
  let shown = true
  let ticking = false

  const isSuppressed = () =>
    document.body.classList.contains('util-SiteOverflowed') ||
    document.body.classList.contains('util-DrawersOpen') ||
    Boolean(document.querySelector('scroll-revealer[search-open]')) ||
    Boolean(document.querySelector('.hd-Header [aria-expanded="true"]'))

  const render = () => {
    ticking = false
    const y = Math.max(window.scrollY, 0)
    const suppressed = isSuppressed()
    const tracking = !shown && !suppressed && y < height

    let offset = 0
    if (!suppressed) {
      offset = shown ? height : Math.min(Math.max(height - y, 0), height)
    }

    root.toggleAttribute('data-lsp-tracking', tracking)
    root.style.setProperty('--LoyaltyTrigger_Offset', `${offset}px`)
    trigger.inert = offset === 0
  }

  const requestRender = () => {
    if (ticking) return
    ticking = true
    window.requestAnimationFrame(render)
  }

  const enableTransitions = () => root.setAttribute('data-lsp-ready', '')

  const handleScroll = () => {
    enableTransitions()

    const y = window.scrollY
    const delta = y - lastY
    lastY = y

    if (y <= 0) {
      shown = true
      upDistance = 0
    } else if (delta > 0) {
      shown = false
      upDistance = 0
    } else if (delta < 0) {
      upDistance -= delta
      if (upDistance >= REVEAL_DISTANCE) shown = true
    }

    requestRender()
  }

  const contentHeight = () =>
    Array.from(trigger.children).reduce((sum, el) => sum + el.offsetHeight, 0)

  /* Keeps the reserved height until the widget has rendered (or never does), then uses the real one. */
  const measure = (force = false) => {
    if (!measured) {
      if (!force && contentHeight() === 0) return
      measured = true
      root.setAttribute('data-lsp-measured', '')
    }

    height = Math.round(trigger.offsetHeight)
    root.style.setProperty('--LoyaltyTrigger_Height', `${height}px`)
    render()
  }

  new ResizeObserver(() => measure()).observe(trigger)
  new MutationObserver(() => measure()).observe(trigger, {
    childList: true,
    subtree: true,
  })
  window.setTimeout(() => measure(true), MEASURE_TIMEOUT)
  measure()

  if (!isProduct) {
    root.setAttribute('data-lsp-above-header', '')

    window.addEventListener('scroll', handleScroll, { passive: true })

    const observer = new MutationObserver(() => {
      if (isSuppressed()) enableTransitions()
      requestRender()
    })
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    })

    const header = document.querySelector('.hd-Header')
    if (header) {
      observer.observe(header, {
        attributes: true,
        attributeFilter: ['aria-expanded'],
        subtree: true,
      })
    }

    const revealer = document.querySelector('scroll-revealer')
    if (revealer) {
      observer.observe(revealer, {
        attributes: true,
        attributeFilter: ['search-open'],
      })
    }
  }
}
